import { createContext, useContext, useState, useCallback } from "react";
import { content, languages } from "@/data/content";

const LanguageContext = createContext(null);
const STORAGE_KEY = "homezen.lang";
const DEFAULT_LANG = "it";

const isValid = (code) => languages.some((l) => l.code === code);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_LANG;
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return isValid(saved) ? saved : DEFAULT_LANG;
  });

  const setLang = useCallback((code) => {
    if (!isValid(code)) return;
    setLangState(code);
    try {
      window.localStorage.setItem(STORAGE_KEY, code);
    } catch (_) {
      /* ignore storage errors */
    }
  }, []);

  const value = { lang, setLang, t: content[lang], languages };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
